import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const ChevronUpIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path
      fillRule="evenodd"
      d="m12 8.707 7.646 7.646.707-.707L12 7.293l-8.354 8.353.708.707L12 8.707Z"
    />
  </IconWrapper>
)

export default ChevronUpIconMedium
